import React, { createContext, useContext, useEffect, useState } from 'react'
import { AttachmentWithTempId } from '../../../types/Upload/Attachment'
import { bulkUploadAttachmentsToStorage } from '../../../services/attachmentService'
import { showWarningToast } from '../../../services/CommonServices/alertServices'

interface AttachmentUploadContextType {
	uploadingAttachments: AttachmentWithTempId[]
	setUploadingAttachments: React.Dispatch<React.SetStateAction<AttachmentWithTempId[]>>
	upload: () => Promise<void>
}

const AttachmentUploadContext = createContext<AttachmentUploadContextType | null>(null)

export const useAttachmentUploadContext = () => {
	const context = useContext(AttachmentUploadContext)
	if (!context) {
		throw new Error('useAttachmentUploadContext must be used within a AttachmentUploadContext')
	}
	return context
}

export const AttachmentUploadProvider = ({ children }: { children: React.ReactNode }) => {
	const [uploadingAttachments, setUploadingAttachments] = useState<AttachmentWithTempId[]>([])

	const upload = async () => {
		if (uploadingAttachments.length > 0) {
			await bulkUploadAttachmentsToStorage(
				uploadingAttachments.filter((att) => att.skip !== true),
				setUploadingAttachments,
			)
		}
	}

	useEffect(() => {
		const handleBeforeUnload = (event: BeforeUnloadEvent) => {
			if (uploadingAttachments.some((att) => att.uploadProgress < 100)) {
                
				event.preventDefault()
				showWarningToast("Attachments upload is ongoing. Closing the app will abort the upload.")
			}
		}

		window.addEventListener('beforeunload', handleBeforeUnload)
		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload)
		}
	}, [uploadingAttachments])

	return (
		<AttachmentUploadContext.Provider
			value={{ uploadingAttachments, setUploadingAttachments, upload }}
		>
			{children}
		</AttachmentUploadContext.Provider>
	)
}
